import { UUID } from 'angular2-uuid';
import { FormControl, FormGroup } from "@angular/forms";

export type QuantityForm = FormGroup<{
  manual: FormControl<boolean>;
  value: FormControl<number>;
}>

export class Quantity {
  manual: boolean;
  value: number;

  constructor(data?: Partial<Quantity>) {
    this.manual = data?.manual ?? false;
    this.value = data?.value ?? 0;
  }

  get description(): string {
    return this.manual ?
      'configuration.quantities.manual.label' :
      this.value.toString() ?? '';
  }
}

export type OverprintForm = FormGroup<{
  id: FormControl<string>;
  description: FormControl<string>;
  value: FormControl<string>;
  type: FormControl<OverprintTypeEnum>;
  x: FormControl<number>;
  y: FormControl<number>;
  width: FormControl<number>;
  maxLines: FormControl<number>;
  color: FormControl<number[]>;
  fontSize: FormControl<number>;
  fontFamily: FormControl<string>;
  fontWeight: FormControl<string>;
}>

export class Overprint {
  id: string;
  description: string;
  value: string;
  type: OverprintTypeEnum;
  x: number;
  y: number;
  width: number;
  maxLines: number;
  color: number[];
  fontSize: number;
  fontFamily: string;
  fontWeight: string;

  constructor(data?: Partial<Overprint>) {
    this.id = data?.id ?? UUID.UUID().toString();
    this.description = data?.description ?? '';
    this.value = data?.value ?? '';
    this.type = data?.type ?? OverprintTypeEnum.GENERIC;
    this.x = data?.x ?? 10;
    this.y = data?.y ?? 50;
    this.width = data?.width ?? 100;
    this.maxLines = data?.maxLines ?? 3;
    this.color = data?.color ?? [0, 0, 0, 100];
    this.fontSize = data?.fontSize ?? 12;
    this.fontFamily = data?.fontFamily ?? 'Arial';
    this.fontWeight = data?.fontWeight ?? '400';
  }
}

export enum OverprintTypeEnum {
  GENERIC = 'generic'
}
